'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fast';
var iconName = 'image';
var width = 512;
var height = 512;
var aliases = [];
var unicode = 'f03e';
var svgPathData = 'M16 48l0 308.7L122.3 250.3l5.7-5.7 5.7 5.7L224 340.7 378.3 186.3l5.7-5.7 5.7 5.7L496 292.7 496 48 16 48zm0 331.3L16 464l84.7 0 112-112L128 267.3 16 379.3zm368-176L123.3 464 496 464l0-148.7-112-112zM0 32l16 0 480 0 16 0 0 16 0 416 0 16-16 0L16 480 0 480l0-16L0 48 0 32zM168 160a40 40 0 1 0 -80 0 40 40 0 1 0 80 0zm-96 0a56 56 0 1 1 112 0A56 56 0 1 1 72 160z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faImage = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;